import { VisitorSliceState } from 'src/core/models'


const visitorState: VisitorSliceState = {
  cookies: {
    loading: true
  }
}
export { visitorState as initialState }
